<div [style]="style" [class]="type==='textarea' ? 'readonly-textarea': 'readonly-input'+ ' '+classS">
  @if(type==='date'){
    {{ value | dateFormat :showHour }}
  }@else {
    {{ value }}
  }
</div>


